import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    marginBottom: '10px',
  },
});

export default useStyles;
